export default function (...text) {
  if (process.env.VUE_APP_MODE != "production") {
    console.log(...text);
  }
}
